export const LIST_SERVICE_REQUEST = 'LIST_SERVICE_REQUEST';
export const LIST_SERVICE_REQUEST_SUCCESS = 'LIST_SERVICE_REQUEST_SUCCESS';
export const LIST_SERVICE_REQUEST_FAILURE = 'LIST_SERVICE_REQUEST_FAILURE';
export const CLEAR_LIST_SERVICES = 'CLEAR_SERVICES';

export const LIST_SERVICE_JURISDICTION_ORGANISM_REQUEST = 'LIST_SERVICE_JURISDICTION_ORGANISM_REQUEST';
export const LIST_SERVICE_JURISDICTION_ORGANISM_REQUEST_SUCCESS = 'LIST_SERVICE_JURISDICTION_ORGANISM_REQUEST_SUCCESS';
export const LIST_SERVICE_JURISDICTION_ORGANISM_REQUEST_FAILURE = 'LIST_SERVICE_JURISDICTION_ORGANISM_REQUEST_FAILURE';
export const CLEAR_LIST_SERVICES_JURISDICTION_ORGANISM = 'CLEAR_LIST_SERVICES_JURISDICTION_ORGANISM';